
<div class="flow-app-widget" :tabindex="tabindex" @click="handleClick($event)">
	<div class="flow-app-name-n-state">
		<div class="flow-app-name">
			<div class="flow-app-state-indicator" :state="state" />
			<h4 class="fc-dark line-h-14 text-ellipsis">
				{{ name }}
			</h4>
		</div>
		<div class="flow-app-state">
			<p class="paragraph-2 fc-light line-h-12 text-ellipsis">
				{{ status }}
			</p>
		</div>
	</div>
	<div class="flow-app-git-details">
		<div class="flow-app-git-commit">
			<Icon
				:name="iconNames.commit"
				state="white"
				size="x-small"
				:effects="false"
				type="filled"
			/>
			<p class="paragraph-2 fc-light line-h-12 text-ellipsis">
				{{ commit }}
			</p>
		</div>
		<div class="flow-app-git-branch">
			<Icon
				:name="iconNames.branch"
				state="white"
				size="x-small"
				:effects="false"
				type="filled"
			/>
			<p class="paragraph-2 fc-light line-h-12 text-ellipsis">
				{{ branch }}
			</p>
		</div>
	</div>
	<div class="flow-app-cost-n-server">
		<div class="flow-app-cost">
			<Icon :name="iconNames.cost" state="white" size="x-small" :effects="false" type="filled" />
			<h5 class="fc-dark">
				{{ cost }}
			</h5>
		</div>
		<div class="flow-app-server">
			<Icon
				:name="iconNames.server"
				state="white"
				size="x-small"
				:effects="false"
				type="filled"
			/>
			<p class="paragraph-2 fc-light line-h-12 text-ellipsis">
				{{ server }}
			</p>
		</div>
	</div>
	<div class="flow-app-state-icons">
		<slot name="icons" />
	</div>
</div>
